const headerTabs = {
  "header.tab.home": "Inicio",
  "header.tab.progress": "Progreso",
  "header.tab.activity": "Actividad",
  "header.tab.playlists": "Listas de reproducción",
  "header.tab.coach": "Entrenador",
};

const headerMenu = {
  "header.menu.rank": "Clasificación",
  "header.menu.bybiq": "BYB IQ",
  "header.menu.switch-profile": "Cambiar perfil",
  "header.menu.settings": "Configuración",
  "header.menu.logout": "Cerrar sesión",
};

const demoAlert = {
  "header.demo-alert.message": "Actualmente estás usando una cuenta de prueba",
  "header.demo-alert.expiry-line": "Tu acceso expira el {{date}}",
};

const exitDialog = {
  "header.exit.switch-profile.title": "Cambiar perfil",
  "header.exit.exit.title": "Salir de la aplicación",
  "header.exit.account.title": "Cuenta",
  "header.exit.admin.title": "Administrador",
  "header.exit.logout.title": "Cerrar sesión",
};

const adminWebOverride = {
  "header.exit.admin.override": "Anulación del entorno web",
  "header.exit.admin.current-url": "URL actual",
  "header.exit.admin.url": "URL",
  "header.exit.admin.add": "Añadir",
  "header.exit.admin.cached-urls": "URLs en caché",
  "header.exit.admin.load": "Cargar",
  "header.exit.admin.clear-url-cache": "Limpiar caché de URLs",
  "header.exit.admin.other": "Otros",
  "header.exit.admin.clear-app-cache": "Limpiar caché de la aplicación",
};

export const header = {
  ...headerTabs,
  ...headerMenu,
  ...demoAlert,
  ...exitDialog,
  ...adminWebOverride,
};
